<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3 py-3"
      >
        <div v-if="dialogWait">
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-2"
            medium
            >mdi-timer-sand</v-icon
          >
          {{ $t("userNewOrderPleaseWaitTitle") }}
        </div>
        <div v-else>
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-2"
            medium
            >mdi-square-edit-outline</v-icon
          >
          {{ $t("userNewPhotoGiftOrderCropTitle") }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-progress-linear
        v-show="dialogWait"
        color="primary"
        height="10"
        indeterminate
      ></v-progress-linear>
      <v-card-text
        class="pa-0 py-1 ma-0 mt-1 d-flex align-center"
        style="overflowy: hidden"
      >
        <v-spacer></v-spacer>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="rotateImage(90)"
        >
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="zoomImage(0.05)"
        >
          <v-icon>mdi-magnify-plus</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="zoomImage(-0.05)"
        >
          <v-icon>mdi-magnify-minus</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="flipXImage()"
        >
          <v-icon>mdi-flip-horizontal</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="flipYImage()"
        >
          <v-icon>mdi-flip-vertical</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="resetImage()"
        >
          <v-icon>mdi-circle-off-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-text>
      <v-card-text class="ma-2 pa-0 mb-0">
        <span
          v-if="quality == 'verylow' || quality == 'low'"
          class="pa-1"
          style="background-color: red; color: white"
          >{{ displayQuality }}</span
        >
        <span
          v-else-if="quality == 'middle'"
          class="pa-1"
          style="background-color: orange; color: white"
          >{{ displayQuality }}</span
        >
        <span
          v-else-if="quality == 'high'"
          class="pa-1"
          style="background-color: green; color: white"
          >{{ displayQuality }}</span
        >
      </v-card-text>
      <v-card-text class="pa-0 my-1 d-flex" style="width: 100%">
        <!-- key je določen zato, ker ponovno renderira cropper ob spremembi viewMode-a -->
        <v-spacer></v-spacer>
        <vueCropper
          :key="viewMode"
          style="overflow: hidden"
          ref="cropper"
          :guides="false"
          :modal="false"
          :checkOrientation="false"
          :toggleDragModeOnDblclick="false"
          :autoCropArea="1.02"
          :rotatable="true"
          :scalable="true"
          :viewMode="viewMode"
          dragMode="move"
          :ready="imReady"
          :highlight="true"
          :containerStyle="{
            'background-color': 'white',
          }"
        ></vueCropper>
        <v-spacer></v-spacer>
      </v-card-text>
      <v-progress-linear
        v-show="dialogWait"
        color="primary"
        height="10"
        indeterminate
      ></v-progress-linear>
      <v-card-actions
        class="pa-2 ma-0"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        style="height: 80px"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="active = false" class="mx-2">{{
          $t("addEditFormCancelButton")
        }}</v-btn>
        <v-btn
          v-if="showButton"
          color="primary elevation-0"
          class="mx-2"
          dark
          @click="cropFinal"
        >
          <v-icon class="mr-1">mdi-crop</v-icon>
          {{ $t("lmBtnCrop") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// VueCropper local import
import "cropperjs/dist/cropper.css";
import VueCropper from "vue-cropperjs";
import * as c from "@/constants";

export default {
  name: "dialog-vue-cropper-basic",
  data() {
    return {
      quality: "high",
      showButton: true, // za reset click.once
      dialogWait: false,
      scaleX: 1,
      scaleY: 1,
    };
  },
  components: {
    VueCropper,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    cropperItem: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Number,
      required: true,
    },
    png: {
      type: Boolean,
      required: false,
    },
    scaleFactor: {
      type: Number,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        if (this.value) {
          this.checkQuality();
          this.replaceImage();
        }
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
    displayQuality() {
      if (this.quality == "high") {
        return this.$t("vueCropperHighQuality");
      } else if (this.quality == "middle") {
        return this.$t("vueCropperMiddleQuality");
      } else if (this.quality == "low") {
        return this.$t("vueCropperLowQuality");
      } else if (this.quality == "verylow") {
        return this.$t("vueCropperVeryLowQuality");
      } else return this.quality;
    },
  },
  methods: {
    imReady() {
      this.dialogWait = false;
    },
    checkQuality() {
      console.log(
        "ORIGINAL:",
        this.cropperItem.oAspectRatio,
        this.cropperItem.oWidth,
        this.cropperItem.oHeight
      );
      console.log(
        "DESTINATION:",
        this.cropperItem.aspectRatio,
        this.cropperItem.width,
        this.cropperItem.height
      );

      // preverjanje kvalitete
      let dW = this.cropperItem.width / this.cropperItem.oWidth;
      let dH = this.cropperItem.height / this.cropperItem.oHeight;

      if (this.cropperItem.oAspectRatio >= 1) {
        // ležeča predloga in ležeča slika za crop
        if (dH > c.G_VUE_CROPPER_QUALITY_VERY_LOW) {
          this.quality = "verylow";
        } else if (dH > c.G_VUE_CROPPER_QUALITY_LOW) {
          this.quality = "low";
        } else if (dH > c.G_VUE_CROPPER_QUALITY_MIDDLE) {
          this.quality = "middle";
        } else {
          this.quality = "high";
        }
      } else {
        // pokončna predloga in pokončna slika za crop
        if (dW > c.G_VUE_CROPPER_QUALITY_VERY_LOW) {
          this.quality = "verylow";
        } else if (dW > c.G_VUE_CROPPER_QUALITY_LOW) {
          this.quality = "low";
        } else if (dW > c.G_VUE_CROPPER_QUALITY_MIDDLE) {
          this.quality = "middle";
        } else this.quality = "high";
      }
      console.log(this.quality);
      console.log(dW, dH);
    },
    replaceImage() {
      this.showButton = true;
      this.dialogWait = true;
      if (this.$refs.cropper != undefined) {
        this.$refs.cropper.destroy();
      }
      // cropper update z novo sliko
      let that = this;
      setTimeout(function () {
        that.$refs.cropper.replace(that.cropperItem.image);
        that.$refs.cropper.setAspectRatio(that.cropperItem.aspectRatio);
      }, 0);
    },
    cropFinal() {
      this.showButton = false;

      let rW = 0;
      let rH = 0;

      if (this.cropperItem.cIndexMode != "addNewSimpleSquareImage") {
        rW = this.cropperItem.width;
        rH = this.cropperItem.height;
      } else {
        let getImageData = this.$refs.cropper.getImageData();
        //let getCanvasData = this.$refs.cropper.getCanvasData();
        let getCropBoxData = this.$refs.cropper.getCropBoxData();

        //console.log("getImageData", getImageData);
        //console.log("getCanvasData", getCanvasData);
        //console.log("getCropBoxData", getCropBoxData);

        rW =
          getCropBoxData.width *
          (getImageData.naturalWidth / getImageData.width);
        rH =
          getCropBoxData.height *
          (getImageData.naturalHeight / getImageData.height);
      }

      if (this.png) {
        console.log("new cropped PNG image");
        this.$emit("croppedImage", {
          image: this.$refs.cropper
            .getCroppedCanvas({
              width: rW * this.scaleFactor,
              height: rH * this.scaleFactor,
              imageSmoothingEnabled: false,
              imageSmoothingQuality: "high",
              //fillColor: "#ffffff"
            })
            .toDataURL("image/png", c.G_FILE_COMPRESSION),
          width: rW * this.scaleFactor,
          height: rH * this.scaleFactor,
        });
      } else {
        console.log(
          "new cropped JPG image original",
          this.cropperItem.width,
          "x",
          this.cropperItem.height
        );
        console.log(
          "new cropped JPG image box",
          rW * this.scaleFactor,
          "x",
          rH * this.scaleFactor
        );

        this.$emit("croppedImage", {
          image: this.$refs.cropper
            .getCroppedCanvas({
              width: rW * this.scaleFactor,
              height: rH * this.scaleFactor,
              imageSmoothingEnabled: false,
              imageSmoothingQuality: "high",
              fillColor: "#ffffff",
            })
            .toDataURL("image/jpeg", c.G_FILE_COMPRESSION),
          width: rW * this.scaleFactor,
          height: rH * this.scaleFactor,
        });
      }
      this.active = false;
      //console.log("cropFinal", this.cropperItem);
    },
    /* VUE CROPPER BUTTON HANDLERS */
    rotateImage(degrees) {
      this.$refs.cropper.rotate(degrees);
    },
    flipXImage() {
      this.scaleX = this.scaleX == 1 ? -1 : 1;
      this.$refs.cropper.scaleX(this.scaleX);
    },
    flipYImage() {
      this.scaleY = this.scaleY == 1 ? -1 : 1;
      this.$refs.cropper.scaleY(this.scaleY);
    },
    zoomImage(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    resetImage() {
      this.$refs.cropper.reset();
      //this.$refs.cropper.relativeZoom(0.02);
      this.scaleX = 1;
      this.scaleY = 1;
    },
  },
};
</script>

<style scoped>
</style>